// Core
import { call, put, select } from 'redux-saga/effects';
import { Map } from 'immutable';

// Instruments
import { orderActions } from 'bus/order/actions';
import { getToursOrder } from '@otpusk/json-api';

export function* sendOrderWorker ({ payload: { form, claim, helpers: { resetForm }}}) {
    try {
        const { token, office } = yield select(({ auth }) => ({
            token:  auth.getIn(['otpusk', 'demo']),
            office: auth.getIn(['otpusk', 'office']),
        }));
        const { adults, date, children, country: countryId, ...contacts } = claim;
        const country = yield select(({ geo }) =>
            geo.get('countries', Map()).find(
                ({ id }) => id === countryId
            )
        );

        const order = {
            country: country ? country.name : '',
            people:  adults || children ? `${adults}${children ? children.map((age) => age > 9 ? age : `0${age}`).join('') : ''}` : null,
            date:    date ? date.format('Y-MM-DD') : null,
            ...contacts,
            office,
        };

        yield call(getToursOrder, token, order);
        yield put(orderActions.sendOrderSuccess(form));
        yield call(resetForm, {
            phone:    '',
            name:     '',
            comment:  '',
            adults:   2,
            children: null,
        });
    } catch (error) {
        yield put(orderActions.sendOrderFail(form));
    }
}
